import { AuthService } from '@jissu-public/shared/core';
import { CrossroadsConfig, NavMenuItem, RoutingMap, RoutingMapItem } from '@jissu-public/shared/model';

export class RoutingMapUtils {
  constructor(private authService: AuthService) {}

  public static mapRoutingMapItem2CrossroadsConfig(routingMapItem: RoutingMapItem): CrossroadsConfig {
    const crossroadsConfig: CrossroadsConfig = {
      title: routingMapItem.title ? routingMapItem.title : '',
      items: [],
    };
    if (routingMapItem.children) {
      Object.values(routingMapItem.children).forEach((child) => {
        crossroadsConfig.items.push({
          title: child.title ? child.title : '',
          subtitle: child.subtitle ? child.subtitle : '',
          routerLink: child.fullPath ? child.fullPath : '',
          roles: child.roles,
        });
      });
    }
    return crossroadsConfig;
  }

  public static getRelativePath(item: RoutingMapItem): string {
    const split = item.fullPath?.split('/');
    return split ? split[split?.length - 1] : '';
  }

  public mapRoutingMap2NavMenuItems(routingMap: RoutingMap | undefined): NavMenuItem[] | undefined {
    if (routingMap == undefined) {
      return undefined;
    }
    const navMenuItemArr: NavMenuItem[] = [];
    Object.values(routingMap).forEach((child) => {
      if ((!child.roles || this.authService.hasRoles(child.roles)) && !child.hidden) {
        navMenuItemArr.push({
          title: child.title ? child.title : '',
          routerLink: child.fullPath,
          children: this.mapRoutingMap2NavMenuItems(child.children),
          roles: child.roles,
        });
      }
    });
    return navMenuItemArr;
  }

  public static mapRoutingMap2NavMenuItemsIgnorRoles(routingMap: RoutingMap | undefined): NavMenuItem[] | undefined {
    if (routingMap == undefined) {
      return undefined;
    }
    const navMenuItemArr: NavMenuItem[] = [];
    Object.values(routingMap).forEach((child) => {
      if (!child.hidden) {
        navMenuItemArr.push({
          title: child.title ? child.title : '',
          routerLink: child.fullPath,
          children: this.mapRoutingMap2NavMenuItemsIgnorRoles(child.children),
          roles: child.roles,
        });
      }
    });
    return navMenuItemArr;
  }
}
